<template>
  <v-card class="ma-5" width="100vw" id="github" color="secondary" flat>
    <v-container>
      <v-row v-if="!milestonesData">
        <Loading size="200" />
      </v-row>
      <v-row justify="center" align="center" v-else>
        <v-timeline>
          <v-timeline-item
            v-for="(stone, idx) in milestonesData.slice(0, 5)"
            :key="idx"
            color="red lighten-2"
            large
          >
            <template v-slot:opposite>
              <span class="headline font-weight-bold">{{
                formatDate(stone.date)
              }}</span>
            </template>
            <v-card class="elevation-2">
              <v-card-text>
                {{ formatText(stone.comment) }}
              </v-card-text>
            </v-card>
          </v-timeline-item>
        </v-timeline>
      </v-row>
    </v-container>
  </v-card>
</template>
<script>
import Loading from "../shared/Loading";
import moment from "moment";

export default {
  name: "Chart",
  components: {
    Loading,
  },
  props: {
    milestonesData: {
      type: Array,
      required: false,
    },
  },
  computed: {
    locale() {
      return this.$store.getters["settings/locale"];
    },
  },
  methods: {
    formatDate(date) {
      return moment(date).format("MM/DD/YYYY");
    },
    capitalizeFirstChar(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    formatText(text) {
      const replaced = text.replace("Comment: ", "");
      const result = this.capitalizeFirstChar(replaced);
      return result;
    },
  },
  mounted() {},
};
</script>
<style scoped></style>
